import Box from '@mui/material/Box';
import React, {useMemo} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {config} from '../../../common/config/config';
import Paper from '@mui/material/Paper';
import {
    constance,
} from '../../../common/constance/constance';
import {common} from '../../../common/common';
import {styles} from '../../../common/style';
import {isMobile} from 'react-device-detect';
import {
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {PostInterface} from '../../../interface/post.interface';
import {MenuInterface} from "../../../interface/menu.interface";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

function buildTagLabel(post: PostInterface, id: any): string {
    const showBoardName = isMobile && (id == 'all' || id == '');
    const boardName = showBoardName ? constance.boardNameMap[post.id] : '';

    if (post.id === 'free' || post.id === 'suggest' || post.id === 'book-report') {
        return boardName;
    }
    if (config.clubId === post.id && post.club != null) {
        const suffix = `${constance.workplaceNameMap[post.club.workplace]} · ${post.club.name}`;
        return boardName ? `${boardName} · ${suffix}` : suffix;
    }
    if (config.departmentId === post.id && post.department != null) {
        const suffix = `${constance.workplaceNameMap[post.department.workplace]} · ${post.department.departmentName}`;
        return boardName ? `${boardName} · ${suffix}` : suffix;
    }
    const suffix = constance.workplaceNameMap[post.workplace];
    return boardName ? `${boardName} · ${suffix}` : suffix;
}

function getTitleBox(post: PostInterface, fontSize: any, fontColor: any, id: any, isRead: boolean) {
    let readColor = '#a1a1a1';
    const tagLabel = buildTagLabel(post, id);

    return (
        <Box sx={{display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', width: 1, gap: isMobile ? 0.5 : 1}}>
            {tagLabel !== '' && (
                <Chip
                    label={tagLabel}
                    size="small"
                    variant="outlined"
                    sx={{
                        height: 22,
                        fontSize: '0.72rem',
                        fontWeight: 600,
                        borderColor: isRead ? 'divider' : fontColor,
                        color: isRead ? readColor : fontColor,
                        backgroundColor: 'var(--scc-card-meta-bg)',
                        opacity: isRead ? 0.7 : 1,
                        maxWidth: isMobile ? '100%' : 'min(60%, 320px)',
                        '.MuiChip-label': {
                            px: 1,
                            ...styles.textHidden,
                        },
                    }}
                />
            )}

            <Box sx={{display: 'flex', alignItems: 'center', minWidth: 0, flex: 1}}>
                <Typography variant={fontSize}
                            align={'left'}
                            sx={{color: isRead ? readColor : 'inherit', ...styles.textHidden, fontWeight: isRead ? 400 : 500}}>
                    {`${post.title}`}
                </Typography>
                {post.replyCount > 0 && (
                    <Typography variant={fontSize}
                                sx={{
                                    color: styles.fontColor.comment,
                                    ml: 0.75,
                                    flexShrink: 0,
                                }}>{`[${post.replyCount}]`}</Typography>
                )}
            </Box>
        </Box>
    );
}

export default function PostListTable(props: { postList: PostInterface[], menu: MenuInterface }) {
    console.log('[PostListTable]');
    const navigate = useNavigate();

    let {id, workplace, no, page, club, department, searchType} = common.getQuery();

    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);

    if (menu == null) {
        menu = {
            allowAdminPost: false,
            allowAdminReply: false,
            id: "",
            index: 0,
            name: "",
            path: "",
            placeholder: "",
            subMenu: [],
            viewComment: false
        }
    }

    function movePostView(post: PostInterface) {
        let club = post.club ? post.club._id : '';
        let department = post.department ? post.department._id : '';
        /* 읽은 게시물 쿠키 저장 */
        let textValue = common.getCookie('rplist');
        let rpList = [];
        if (textValue) {
            rpList = JSON.parse(textValue);
        }
        rpList.push(post._id);
        common.setCookie('rplist', JSON.stringify(rpList), 60 * 24 * 14);
        navigate(`${config.url.postView}?id=${post.id}&no=${post.no}&workplace=${workplace}&club=${club}&department=${department}&search-type=${searchType}`);
    }

    function blockPostView() {
        common.alert('열람 제한', '해당 게시물은 열람이 제한되어있습니다.', 'info');
    }


    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";
    let fontColor: any = 'var(--scc-category-tag)';
    let textValue = common.getCookie('rplist');
    let rpList: any = [];
    if (textValue) {
        rpList = JSON.parse(textValue);
    }
    return (
        <>
            {
                isMobile ?
                    <Paper
                        elevation={0}
                        sx={{
                            width: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            background: 'var(--scc-card-bg)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            borderRadius: 2,
                            border: 1,
                            borderColor: 'divider',
                            overflow: 'hidden',
                        }}>
                        {
                            props.postList.map((post, index) => {
                                const isRead: boolean = rpList.includes(post._id);
                                const tagLabel = buildTagLabel(post, id);
                                const isLast = index === props.postList.length - 1;
                                return (
                                    <Box key={index}
                                         onClick={post.isBlockView ? () => blockPostView() : () => movePostView(post)}
                                         sx={{
                                             width: 1,
                                             px: 1.5,
                                             py: 1.25,
                                             borderBottom: isLast ? 'none' : '1px solid',
                                             borderColor: 'divider',
                                             cursor: 'pointer',
                                             transition: 'background-color 0.15s',
                                             '&:hover, &:active': {
                                                 backgroundColor: 'var(--scc-card-meta-bg)',
                                             },
                                         }}>
                                        {/* Chip */}
                                        {tagLabel !== '' && (
                                            <Box sx={{mb: 0.75}}>
                                                <Chip
                                                    label={tagLabel}
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{
                                                        height: 20,
                                                        fontSize: '0.7rem',
                                                        fontWeight: 600,
                                                        borderColor: isRead ? 'divider' : fontColor,
                                                        color: isRead ? '#a1a1a1' : fontColor,
                                                        backgroundColor: 'var(--scc-card-meta-bg)',
                                                        opacity: isRead ? 0.7 : 1,
                                                        maxWidth: '100%',
                                                        '.MuiChip-label': {
                                                            px: 0.75,
                                                            ...styles.textHidden,
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {/* 제목 + 댓글 수 */}
                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 0.5}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                    color: isRead ? '#a1a1a1' : 'inherit',
                                                    fontWeight: isRead ? 400 : 500,
                                                    lineHeight: 1.4,
                                                    wordBreak: 'keep-all',
                                                }}>
                                                {post.title}
                                            </Typography>
                                            {post.replyCount > 0 && (
                                                <Stack direction="row"
                                                       spacing={0.3}
                                                       alignItems="center"
                                                       sx={{
                                                           color: 'text.secondary',
                                                           flexShrink: 0,
                                                           opacity: isRead ? 0.6 : 0.85,
                                                       }}>
                                                    <ChatBubbleOutlineIcon sx={{fontSize: 13}}/>
                                                    <Typography variant="caption" sx={{fontWeight: 600}}>
                                                        {post.replyCount}
                                                    </Typography>
                                                </Stack>
                                            )}
                                        </Box>

                                        {/* 메타: 작성자 · 시간 · 조회수 */}
                                        <Stack direction="row"
                                               alignItems="center"
                                               sx={{
                                                   color: 'text.secondary',
                                                   flexWrap: 'wrap',
                                                   rowGap: 0.25,
                                                   opacity: isRead ? 0.6 : 1,
                                               }}>
                                            <Typography variant="caption" sx={styles.textKeepAll}>
                                                {`${post.user.departmentName} ${post.user.name}`}
                                            </Typography>
                                            <Box component="span"
                                                 sx={{mx: 0.75, opacity: 0.5}}>·</Box>
                                            <Typography variant="caption">
                                                {common.getTimeFormat(post.createdAt)}
                                            </Typography>
                                            <Box component="span"
                                                 sx={{mx: 0.75, opacity: 0.5}}>·</Box>
                                            <Typography variant="caption">
                                                조회 {post.hitCount}
                                            </Typography>
                                        </Stack>
                                    </Box>
                                )
                            })
                        }

                    </Paper>
                    :
                    <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{
                            background: 'var(--scc-card-bg)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            borderRadius: 2,
                            border: 1,
                            borderColor: 'divider',
                        }}
                    >
                        <Table sx={{minWidth: 300}} size={'medium'} aria-label="a dense table">
                            <TableHead>
                                <TableRow sx={{'th': {padding: '16px'}}}>
                                    <TableCell align="center">{(id == 'all' || id == '') ? '게시판' : '글번호'}</TableCell>
                                    <TableCell align="center" sx={{minWidth: 0.5}}><Typography
                                        variant={fontSize}>제목</Typography></TableCell>
                                    <TableCell align="center"><Typography
                                        variant={fontSize}>등록자</Typography></TableCell>
                                    <TableCell align="center"><Typography
                                        variant={fontSize}>조회수</Typography></TableCell>
                                    <TableCell align="center"><Typography
                                        variant={fontSize}>등록일</Typography></TableCell>
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {props.postList.map((post, index) => {
                                    let isRead: boolean = rpList.includes(post._id);
                                    let color: string = isRead ? 'rgba(103,103,103,0.53)' : 'inherit';
                                    return <React.Fragment key={index}>
                                        <TableRow
                                            onClick={post.isBlockView ? () => blockPostView() : () => movePostView(post)}
                                            sx={{
                                                width: 1,
                                                '&:last-child td, &:last-child th': {border: 0},
                                                'td': {padding: '8px'},
                                                cursor: 'pointer',
                                                ':hover': {
                                                    background: styles.tableHoverColor,
                                                },
                                                transition: styles.transition,
                                            }}
                                        >
                                            {/* 게시글 번호 */}
                                            {
                                                isMobile ? '' :
                                                    <TableCell component="th" scope="row" align="center"
                                                               sx={{width: 0.15}}>
                                                        <Typography
                                                            variant={fontSize}> {(id == 'all' || id == '') ? constance.boardNameMap[post.id] : post.no}</Typography>
                                                    </TableCell>
                                            }


                                            {/* 제목 */}
                                            <TableCell align="left" sx={{maxWidth: {xs: 0.5, sm: 0.5,}}}>
                                                {getTitleBox(post, fontSize, fontColor, id, isRead)}
                                            </TableCell>

                                            {/* 등록자 */}
                                            <TableCell align="center" sx={{width: {xs: 0.25, sm: 0.25, md: 0.15}}}>
                                                <Stack>
                                                    <Typography variant={fontSize} sx={{...styles.textKeepAll}}>
                                                        {`${post.user.departmentName} ${post.user.name}`}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>

                                            {/* 조회수 */}
                                            {
                                                isMobile ? '' :
                                                    <TableCell align="center"
                                                               sx={{width: {xs: 0.25, sm: 0.25, md: 0.1}}}>
                                                        <Typography variant={fontSize}>{post.hitCount}</Typography>
                                                    </TableCell>
                                            }

                                            {/* 생성일 */}
                                            <TableCell align="center" sx={{width: 0.2}}>
                                                <Typography
                                                    variant={fontSize}>{common.getTimeFormat(post.createdAt)}</Typography>
                                            </TableCell>
                                        </TableRow>


                                        {/* 답글이 있는 게시판일 경우 => 답글 생성*/}
                                        {
                                            props.menu.viewComment && post.comment.content ?
                                                <TableRow key={index + "_sub"}
                                                          sx={{
                                                              '&:last-child td, &:last-child th': {border: 0},
                                                              'td': {padding: '8px'},
                                                              cursor: 'pointer',
                                                              ':hover': {
                                                                  background: styles.tableHoverColor,
                                                              },
                                                              transition: styles.transition,
                                                          }}
                                                >
                                                    {
                                                        isMobile ? '' :
                                                            <TableCell align="center"
                                                                       component="th" scope="row">
                                                            </TableCell>
                                                    }
                                                    <TableCell align="left">
                                                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                                                            <SubdirectoryArrowRightIcon
                                                                sx={{
                                                                    opacity: 0.7,
                                                                    mr: 1,
                                                                    color: styles.fontColor.comment
                                                                }}
                                                                fontSize={"small"}/>
                                                            <Typography variant={fontSize}
                                                                        sx={{color: styles.fontColor.comment}}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: `${post.comment.content}`,
                                                                        }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Stack>
                                                            <Typography variant={fontSize} noWrap={true}>
                                                                {`${post.comment.user.departmentName}`}
                                                                &nbsp;
                                                                {`${post.comment.user.name}`}
                                                            </Typography>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Typography
                                                            variant={fontSize}>{common.getTimeFormat(post.comment.createdAt)}</Typography>
                                                    </TableCell>
                                                </TableRow> : ''
                                        }

                                    </React.Fragment>
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
            }


        </>
    );
}
